import React, {
  Fragment,
  useState,
  useRef,
  useEffect,
  useLayoutEffect,
} from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import { Row, Col, Card, Tabs, Tab, Nav } from "react-bootstrap";

import { Formik } from "formik";
import * as Yup from "yup";
// import { useAuth, currentUser } from "../../../context/AuthContext";
import { db } from "../../../../firebase";
import {
  setDoc,
  getDoc,
  getDocs,
  collection,
  updateDoc,
  doc,
} from "firebase/firestore";
import {
  PatientTextInputForm,
  PatientTextInputNotRequiredForm,
  PatientDropDownForm,
} from "../PatientUtils";
import {
  notifyTopRight,
  notifyWarning,
  notifyError,
} from "../../../components/toast/SetToast";
import Toast from "../../../components/toast/SetToast";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import {
  berlinQuestionnaireData,
  berlinQuestionnaireTitle,
  berlinQuestionnaireChoices,
} from "../../Patient/formData/berlinQuestionnaireData";
import profileData from "../../Patient/formData/profileData";

const formTitle = berlinQuestionnaireTitle;
const infoData = berlinQuestionnaireData;
const Questions = Object.keys(berlinQuestionnaireData);
const Choices = berlinQuestionnaireChoices;

const FormStates = {
  assign: false,
  formname: formTitle,
  id: "6",
  info: infoData,
  submit: false,
};

const BerlinQuestionnaire = () => {
  const FormRef = useRef(infoData);
  const history = useHistory();
  const [patientInfo, setPatientInfo] = useState(profileData);
  const [FormDoc, setFormDoc] = useState(FormStates);
  const [isLoading, setLoading] = useState(true);
  const { id, uuid } = useParams();
  const DropdownBox = ({
    title = "",
    htmlFor = "",
    id = "",
    name = "",
    refvalue,
    placeholder = "Please select",
    options = [""],
    defaultValue,
  }) => {
    return (
      <div className="form-group row">
        <label className="col-lg-5 col-form-label" htmlFor={htmlFor}>
          {title}
          <span className="text-danger"></span>
        </label>
        <div className="col-lg-6">
          <select
            className="form-control"
            id={id}
            name={name}
            ref={refvalue}
            defaultValue={defaultValue}
          >
            {options.map((value) => (
              <option value={value}>{value}</option>
            ))}
          </select>
        </div>
      </div>
    );
  };
  const InputBox = ({
    title = "",
    value = "",
    placeholder = "",
    id = "",
    measure = "",
    refValue,
    noBox = false,
    defaultValue,
  }) => {
    return (
      <div className="form-group row">
        <label className="col-xl-5 col-form-label mt-2">{title}</label>
        <div className="col-xl-6">
          {noBox == false && (
            <input
              type="text"
              className="form-control"
              // placeholder={placeholder == "" ? title : placeholder}
              id={id}
              ref={refValue}
              defaultValue={defaultValue}
            />
          )}
        </div>
        <div className="ml-3 mt-3">
          <text>{measure}</text>
        </div>
      </div>
    );
  };
  const InputRadio = ({
    title = "",
    id = "",
    options = [""],
    checked = "",
    name = "",
    isnote = false,
    note = "",
    mt = "row mt-3",
    refValue,
    refNote,
    required,
  }) => {
    return (
      <fieldset className="form-group">
        <div className={mt}>
          <label className="col-xl-5 col-form-label pt-0">{title}</label>
          <div className="col-xl-6">
            {options.map((value) => {
              return (
                <>
                  <div className="form-check">
                    <label className="form-check-label">
                      <input
                        className="form-check-input"
                        type="radio"
                        name={name}
                        required={required}
                        value={value}
                        onChange={(e) => {
                          if (typeof refValue == "string") {
                            FormRef.current[refValue] = e.target.value;
                          } else {
                            FormRef.current[refValue[0]][refValue[1]] =
                              e.target.value;
                          }
                        }}
                        defaultChecked={checked == value ? "checked" : ""}
                      />
                      {value}
                    </label>
                  </div>
                </>
              );
            })}
          </div>
          {isnote && (
            <div className="form-check">
              {" "}
              <textarea
                className="form-control"
                id="val-suggestions"
                name="val-suggestions"
                rows="2"
                placeholder=""
                ref={(e) => {
                  FormRef.current[refNote] = e;
                }}
                defaultValue={note}
              ></textarea>
            </div>
          )}
        </div>
      </fieldset>
    );
  };
  const InputCheckBox = ({
    title = "",
    id = "",
    options = [""],
    checked = [""],
    name = "",
    refValue,
    mt = "row mt-3",
  }) => {
    return (
      <fieldset className="form-group">
        <div className={mt}>
          <label className="col-xl-4 col-form-label pt-0">{title}</label>
          <div className="col-xl-2">
            {options.map((value) => {
              return (
                <>
                  <div className="form-check">
                    <label className="form-check-label">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name={name}
                        value={value}
                        onChange={(e) => {
                          console.log(e.target.value);
                        }}
                        defaultChecked={
                          checked.includes(value) ? "checked" : ""
                        }
                      />
                      {value}
                    </label>
                  </div>
                </>
              );
            })}
          </div>
        </div>
      </fieldset>
    );
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    var info = berlinQuestionnaireData;

    Object.keys(info).forEach((key) => {
      info[key] = FormRef.current[key];
      console.log(key, info[key]);
    });

    const ref = doc(db, "patients", patientInfo.hn, "form", uuid);
    const docSnap = await getDoc(ref);
    if (docSnap.exists()) {
      try {
        var tmpDocSnap = docSnap.data();
        tmpDocSnap.info = info;
        tmpDocSnap.submit = true;
        var dateNow = new Date();
        dateNow.setHours(dateNow.getHours() + 7);
        tmpDocSnap.updateAt = dateNow.toISOString();
        console.log(tmpDocSnap);
        await updateDoc(ref, tmpDocSnap);
        notifyTopRight("บันทึกข้อมูลสำเร็จ");
      } catch (err) {
        notifyError("บันทึกข้อมูลผิดพลาด, ", err);
      }
    }
  };
  useEffect(async () => {
    if (patientInfo.hn != undefined && patientInfo.hn != "") {
      let docColRef = doc(db, "patients", id, "form", uuid);
      let docSnapForm = await getDoc(docColRef);
      console.log(docSnapForm.data());
      console.log(FormStates.formname);
      setFormDoc(docSnapForm.data());
      setLoading(false);

      // set up Ref for all radio  input
      Object.keys(docSnapForm.data().info).forEach((key) => {
        FormRef.current[key] = docSnapForm.data().info[key];
      });

      return;
    }

    const ref = await doc(db, "patients", id);
    const docSnap = await getDoc(ref);
    setPatientInfo(docSnap.data());
  }, [patientInfo]);

  console.log(FormDoc);

  return (
    <Fragment>
      <Toast />

      <Col xl={12}>
        <Card>
          <Card.Header>
            <Card.Title>{formTitle}</Card.Title>
          </Card.Header>
          <Card.Body>
            {!isLoading ? (
              <div className="basic-form">
                <form onSubmit={submitHandler}>
                  <div className="row">
                    <div className="col-xl-7">
                      <h4 className="mb-4">
                        <b>คำถามกลุ่มที่ 1</b>
                      </h4>
                      <InputRadio
                        title={Questions[0]}
                        name={Questions[0]}
                        options={Choices[Questions[0]]}
                        checked={FormDoc.info[Questions[0]]}
                        refValue={Questions[0]}
                        required={true}
                      ></InputRadio>
                      <InputRadio
                        title={Questions[1]}
                        name={Questions[1]}
                        options={Choices[Questions[1]]}
                        checked={FormDoc.info[Questions[1]]}
                        refValue={Questions[1]}
                        required={true}
                      ></InputRadio>
                      <InputRadio
                        title={Questions[2]}
                        name={Questions[2]}
                        options={Choices[Questions[2]]}
                        checked={FormDoc.info[Questions[2]]}
                        refValue={Questions[2]}
                        required={true}
                      ></InputRadio>
                      <InputRadio
                        title={Questions[3]}
                        name={Questions[3]}
                        options={Choices[Questions[3]]}
                        checked={FormDoc.info[Questions[3]]}
                        refValue={Questions[3]}
                        required={true}
                      ></InputRadio>
                      <InputRadio
                        title={Questions[4]}
                        name={Questions[4]}
                        options={Choices[Questions[4]]}
                        checked={FormDoc.info[Questions[4]]}
                        refValue={Questions[4]}
                        required={true}
                      ></InputRadio>
                      <h4 className="mb-4">
                        <b>คำถามกลุ่มที่ 2</b>
                      </h4>
                      <InputRadio
                        title={Questions[5]}
                        name={Questions[5]}
                        options={Choices[Questions[5]]}
                        checked={FormDoc.info[Questions[5]]}
                        refValue={Questions[5]}
                        required={true}
                      ></InputRadio>
                      <InputRadio
                        title={Questions[6]}
                        name={Questions[6]}
                        options={Choices[Questions[6]]}
                        checked={FormDoc.info[Questions[6]]}
                        refValue={Questions[6]}
                        required={true}
                      ></InputRadio>
                      <InputRadio
                        title={Questions[7]}
                        name={Questions[7]}
                        options={Choices[Questions[7]]}
                        checked={FormDoc.info[Questions[7]]}
                        refValue={Questions[7]}
                        required={true}
                      ></InputRadio>
                      <InputRadio
                        title={Questions[8]}
                        name={Questions[8]}
                        options={Choices[Questions[8]]}
                        checked={FormDoc.info[Questions[8]]}
                        refValue={Questions[8]}
                        required={true}
                      ></InputRadio>
                      <h4 className="mb-4">
                        <b>คำถามกลุ่มที่ 3</b>
                      </h4>
                      <InputRadio
                        title={Questions[9]}
                        name={Questions[9]}
                        options={Choices[Questions[9]]}
                        checked={FormDoc.info[Questions[9]]}
                        refValue={Questions[9]}
                        required={true}
                      ></InputRadio>
                    </div>
                  </div>

                  <div className="form-group row">
                    <div className="col-sm-10">
                      <button type="submit" className="btn btn-primary">
                        บันทึกข้อมูล
                      </button>

                      <button
                        onClick={() => {
                          history.push(`/patient-page/${id}`);
                        }}
                        type="submit"
                        className="btn btn-light ml-2"
                      >
                        ยกเลิก
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            ) : (
              <></>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Fragment>
  );
};

export default BerlinQuestionnaire;
